import { UIElement } from '../ui-element';
import { html } from '../../global/template-literals';
import { Component } from '../../decorators/component.decorator';
import styles from './ui-header-toolbar.css';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIHeaderToolbar
 * @element ui-header-toolbar
 * @classdesc Represents a class for <code>ui-header-toolbar</code> element.
 * @slot {@name environment} Environment selector slot.
 * @slot {@name language} Language selector slot.
 * @slot {@name login-button} Login button selector slot.
 * @example
 * <ui-header-toolbar>
 * </ui-header-toolbar>
 */
@Component({ tag: 'ui-header-toolbar', styles })
export class UIHeaderToolbar extends UIElement {
    /**
     * @inheritDoc
     */
    override render(): void {
        const environmentToggle = this.getChildrenForSlot('environment')[0];
        const languageSelector = this.getChildrenForSlot('language')[0];
        const loginButton = this.getChildrenForSlot('login-button')[0];
        const toolbarNodes = this.detachChildNodes();

        environmentToggle?.classList.add('ui-header-toolbar__environment');
        languageSelector?.classList.add('ui-header-toolbar__language');
        loginButton
            ?.closest('button')
            ?.classList.add('ui-header-toolbar__login');

        this.append(
            html` ${environmentToggle} ${toolbarNodes} ${languageSelector}
            ${loginButton}`
        );
    }
}
